import { render } from "./PanelistLandingPage.vue?vue&type=template&id=6bd439e4&ts=true"
import script from "./PanelistLandingPage.vue?vue&type=script&lang=ts"
export * from "./PanelistLandingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__